import Api from './ApiRequest';

export default  {
    getAll: (params) => Api.get('/cent/calendars', params),
    getById: (id) => Api.get('/cent/calendar/' + id, null),
    save: (entity) => Api.post('/cent/calendar', entity),
    update: (id, entity) => Api.put('/cent/calendar/' + id, entity),
    delete: (id) => Api.delete('/cent/calendar/' + id),
    search: (searchText) => Api.get('/cent/calendars/search', {q: searchText}),
    getEventsForCalendar: (id) => Api.get('/cent/calendar/' + id + '/events'),
};